import request from '@/api/request'

export function changePassword (data) {
  return request({
    url: '/password/change',
    method: 'post',
    data
  })
}

export function recoverPassword (data) {
  return request({
    url: '/password/recover',
    method: 'post',
    data
  })
}

export function resetPassword (data) {
  return request({
    url: '/password/reset',
    method: 'post',
    data
  })
}
